<template>
  <div>
    <div ref="container" :style="{ fontSize: fontSize }">
      <svg id="svg" viewBox="0 0 175 50" preserveAspectRatio="xMinYMin">
        <rect x="0" y="0" width="175" height="10" fill="#009879" />
        <text x="30" y="7" font-size="7" fill="white" font-weight="bold">
          MAP
        </text>
        <text x="100" y="7" font-size="7" fill="white" font-weight="bold">
          Duration
        </text>

        <rect x="0" y="10" width="175" height="10" fill="#f3f3f3" />
        <text x="25" y="17" font-size="6">In target</text>
        <text x="95" y="17" font-size="6">{{ inTarget }}</text>

        <rect x="0" y="20" width="175" height="10" fill="white" />
        <text x="21" y="27" font-size="6">Above target</text>
        <text x="95" y="27" font-size="6">{{ aboveTarget }}</text>

        <rect x="0" y="30" width="175" height="10" fill="#f3f3f3" />
        <text x="20" y="37" font-size="6">Under target</text>
        <text x="97" y="37" font-size="6">{{ underTarget }}</text>

        <rect x="0" y="19.5" width="175" height="1" fill="#dddddd" />
        <rect x="0" y="29.5" width="175" height="1" fill="#dddddd" />

        <rect x="0" y="40" width="175" height="2" fill="#009879" />
      </svg>
    </div>
  </div>
</template>

<script>
import { textFitMixin } from '@/components/TextFitMixin'

export default {
  name: 'TargetTable',
  mixins: [textFitMixin],
  props: {
    totalSeconds: { default: 0 },
    secondsInTarget: { default: 0 },
    secondsUnderTarget: { default: 0 },
    secondsAboveTarget: { default: 0 }
  },
  computed: {
    inTarget() {
      let fraction = ((this.secondsInTarget / this.totalSeconds) * 100).toFixed(
        0
      )
      let hours = Math.floor(this.secondsInTarget / 3600).toFixed(0)
      let mins = ((this.secondsInTarget % 3600) / 60).toFixed(0)
      return `${fraction}% (${hours}h ${mins}m)`
    },
    aboveTarget() {
      let fraction = (
        (this.secondsAboveTarget / this.totalSeconds) *
        100
      ).toFixed(0)
      let hours = Math.floor(this.secondsAboveTarget / 3600).toFixed(0)
      let mins = ((this.secondsAboveTarget % 3600) / 60).toFixed(0)
      return `${fraction}% (${hours}h ${mins}m)`
    },
    underTarget() {
      let fraction = (
        (this.secondsUnderTarget / this.totalSeconds) *
        100
      ).toFixed(0)
      let hours = Math.floor(this.secondsUnderTarget / 3600).toFixed(0)
      let mins = ((this.secondsUnderTarget % 3600) / 60).toFixed(0)
      return `${fraction}% (${hours}h ${mins}m)`
    }
  }
}
</script>

<style scoped>
#svg {
  width: 100%;
  margin: 0;
}
</style>
